import React from "react";
import PropTypes from "prop-types";

const ArrowTopLeft = ({ className }) => {
  return (
    <svg className={className} viewBox="0 0 31.11 29.86">
      <g id="Layer_5" data-name="Layer 5">
        <path d="M31.11,28.58A9.92,9.92,0,0,1,18.62,19V17.57A10.91,10.91,0,0,0,7.72,6.67H3.19l-1.31,0A13.38,13.38,0,0,0,7.06.77l0-.1L6.43,0,6.34.2A12.06,12.06,0,0,1,.09,6.66l0,0,0,0v.87H0l0,0,.15.07a12.13,12.13,0,0,1,6.2,6.5l.09.2.67-.67,0-.1A13.37,13.37,0,0,0,2,7.63l1.25,0H7.72a10,10,0,0,1,10,10V19a10.91,10.91,0,0,0,10.9,10.9,11,11,0,0,0,2.53-.31Z" />
      </g>
    </svg>
  );
};

ArrowTopLeft.defaultProps = {
  className: ``
};

ArrowTopLeft.propTypes = {
  className: PropTypes.string
};

export default ArrowTopLeft;
